/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetChatIdRequest, TGetChatIdModel, IMappers, TGetChatIdResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV1GetChatIdResponse } from '../../entities/entities/V1GetChatIdResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetChatIdModel(parameters: IGetChatIdRequest): TGetChatIdModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'cpd',
    pathApi: '/v1/get-chat-id/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetChatIdOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetChatIdRequest;
}

export async function fetchGetChatId<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetChatIdOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetChatIdResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetChatIdModel(parameters),
    config,
  )) as FetchResponse<TGetChatIdResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV1GetChatIdResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetChatIdResponse>;
}
